import type { ReactNode } from 'react';
import { useEffect } from 'react';

import { useSearchParams } from 'react-router';

import { FullScreenLoader } from './FullScreenLoader';
import { LoadingPageWithText } from './LoadingPageWithText';
import { useTOSContext } from './TOSProvider';

export const LoadingPage = (): ReactNode => {
  const [queryParams] = useSearchParams();
  const { forceHideTOSModal } = useTOSContext();

  // DO NOT REMOVE: Do not show the TOS modal on this page
  useEffect(() => {
    // set this as false on the initial render - so it doesn't show it on this page
    forceHideTOSModal(true);
    return () => {
      // allow the TOS component to be shown when we unmount
      forceHideTOSModal(false);
    };
  }, [forceHideTOSModal]);

  if (queryParams.get('refresh_offer') === 'true') {
    return <LoadingPageWithText text="Updating your offer" />;
  }

  return <FullScreenLoader />;
};
